<div class="mb-3">
  <div class="form-check form-switch ">
    <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
      <input type="checkbox" class="form-check-input" [id]="'check'+inputContent.inputContentGuid"
        [formControl]="formControlObj">
    </app-field-title>
  </div>
</div>